// extracted by mini-css-extract-plugin
module.exports = {"container":"CardConfirmation_container__Qlcas"};